import { render, staticRenderFns } from "./CreateRepairedBatch.vue?vue&type=template&id=70c70322&scoped=true&"
import script from "./CreateRepairedBatch.vue?vue&type=script&lang=js&"
export * from "./CreateRepairedBatch.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70c70322",
  null
  
)

export default component.exports